/**
 * Client-side filtering for posts to avoid server action payload issues
 */

export const filterPosts = (posts, filters) => {
  if (!posts || !filters || filters.length === 0) {
    return posts;
  }

  let filteredPosts = [...posts];

  // Search filter
  const searchFilters = filters.filter((filter) => filter.type === 'search');
  if (searchFilters.length > 0) {
    filteredPosts = filteredPosts.filter((post) => {
      const title = post.title || '';
      
      return searchFilters.every((filter) => {
        const searchValue = filter.value.toLowerCase();
        return title.toLowerCase().includes(searchValue);
      });
    });
  }

  return filteredPosts;
};

export const filterPostsByTag = (posts, tag) => {
  if (!tag) {
    return posts;
  }

  return posts.filter((post) =>
    post.tags?.map((tag) => tag.slug).includes(tag)
  );
};
